import tw, { TwStyle, styled } from 'twin.macro';

type Variant =
  | 'cyan'
  | 'gray'
  | 'sea-green'
  | 'purple'
  | 'green'
  | 'orange'
  | 'blue'
  | 'dark-blue'
  | 'pink';

export default function Tag({
  variant,
  text,
  progress,
}: {
  variant: Variant;
  text: string;
  progress?: number;
}) {
  const transitionalStatus = !isNaN(Number(progress));

  return (
    <TagWrapper className={transitionalStatus ? 'animate-breathe' : ''} $variant={variant}>
      {text}{' '}
      <span className="font-normal">{transitionalStatus ? `(${progress}%)` : undefined}</span>
    </TagWrapper>
  );
}

const TagWrapper = styled.div<{
  $variant: Variant;
}>(({ $variant }) => [
  varinatStylesMap[$variant],
  tw`
    rounded-[4px] px-[6px] py-[4px] w-fit text-[12px] leading-[16px] font-bold
    `,
]);

const varinatStylesMap: Record<Variant, TwStyle> = {
  cyan: tw`bg-spiro text-white`,
  gray: tw`bg-azureish-white text-[#5579B8]`,
  'sea-green': tw`bg-sea-green text-white`,
  purple: tw`bg-electric-indigo text-white`,
  pink: tw`bg-magenta text-white`,
  green: tw`bg-green text-white`,
  orange: tw`bg-orange text-white`,
  blue: tw`bg-azure text-white`,
  'dark-blue': tw`bg-primary-900 text-white`,
};
